import { JSX } from 'react'

import { TwoLineFragment } from '~/components/component-library'

/** The payment-source field's empty state, shared by the disabled pre-fill placeholder and the populated select. */
export const PaymentSourcePlaceholder = (): JSX.Element => (
  <TwoLineFragment
    size="small"
    placeholder
    topLine={<span className="truncate">Select a token to sell</span>}
    bottomLine={<span className="truncate">Balance available per network</span>}
  />
)
